<template>
    <ticto-loading v-if="loading" />
    <div class="my-5">
        <div style="display: flex">
            <ArchiveBoxIcon class="mr-2 h-8 w-7 flex-shrink-0 text-gray-400" />
            <h3 class="mb-5 text-lg font-medium leading-9 dark:text-white" v-if="releaseNew">
            Release Notes - Versão: {{ releaseNew?.version }} - Detalhes
        </h3>
        <div v-else>
            Carregando...
        </div>
        </div>
        <div class="flex justify-end p-4">
            <button
                @click="returnRedirect()"
                :disabled="loading"
                type="button"
                :class="{ 'cursor-not-allowed': loading }"
                class="ml-2 inline-flex items-center justify-center rounded-md bg-indigo-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
            >
                <ArrowLeftIcon
                    class="mr-2 h-8 w-7 flex-shrink-0 text-gray-400"
                />
                Voltar
            </button>
            <button
                @click="openModal()"
                class="ml-2 inline-flex items-center justify-center rounded-md bg-sky-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
            >
                <PlusIcon class="mr-2 h-5 w-5" aria-hidden="true" />

                Novo
            </button>
        </div>

        <div class="mt-10">
            <table class="w-full table-auto border-collapse text-sm">
                <thead class="bg-white dark:bg-slate-800">
                    <tr>
                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Título
                        </th>
                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Nome Produtor/Solicitante
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Serviço
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Texto
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Ações
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-slate-800">
                    <tr v-for="release in releases">
                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.title }}
                        </td>
                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.producer }}
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.service }}
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.text }}
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            <button
                                @click="openmodalAnexos(release)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-sky-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                            >
                                <DocumentIcon
                                    class="text-black-400 mr-2 h-8 w-7 flex-shrink-0"
                                />
                                Anexos
                            </button>
                        </td>

                        <td>
                            <button
                                @click="openModal(release)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-yellow-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                            >
                                <PencilIcon
                                    class="text-black-400 mr-2 h-8 w-7 flex-shrink-0"
                                />
                                Editar
                            </button>
                        </td>
                        <td>
                            <button
                                @click.prevent="destroy(release.id)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-red-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-red-400"
                            >
                                <TrashIcon
                                    class="text-black-400 mr-2 h-8 w-7 flex-shrink-0"
                                />
                                Excluir
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <modal size="4xl" :open="modalAnexos" @close="modalAnexos = false">
        <div
            class="flex min-h-fit w-full flex-col flex-wrap space-y-3 divide-y divide-slate-500 text-white"
        ></div>
        <h1
            class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-white"
        >
            Anexos
        </h1>

        <div v-for="(videos, index) in video" class="text-center">
            <iframe
                width="560"
                height="315"
                :src="videos.temporary_url"
                class="h-full w-full"
                frameborder="0"
                allowfullscreen
            ></iframe>

            <button
                @click.prevent="destroyImage(videos.id)"
                :disabled="loading"
                type="button"
                :class="{ 'cursor-not-allowed': loading }"
                class="mb-10 ml-2 mt-4 inline-flex items-center rounded-md bg-red-500 px-2 py-1 text-sm font-semibold text-white shadow transition duration-150 ease-in-out hover:bg-red-400"
            >
                <TrashIcon class="mr-2 h-8 w-7 flex-shrink-0 text-gray-400" />
                Excluir
            </button>
        </div>
    </modal>

    <modal size="4xl" :open="modal" @close="modal = false">
        <div
            class="flex min-h-fit w-full flex-col flex-wrap space-y-3 divide-y divide-slate-500 text-white"
        ></div>
        <h1
            class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-white"
        >
            Novo Detalhe
        </h1>

        <form @submit.prevent="submitForm">
            <div class="mt-5 flex-col sm:mt-4 sm:flex">
                <div class="mb-3 grid gap-2 sm:grid-cols-2">
                    <div>
                        <label class="text-white">Título</label>
                        <input
                            type="text"
                            id="title"
                            v-model="form.title"
                            name="title"
                            class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                            placeholder="Ex: TIC2-6365 - Incluir Filtro de Períodos na Gestão de Afiliados"
                            required
                        />
                    </div>

                    <div>
                        <label class="text-white">
                            Nome Produtor/Solicitante
                        </label>
                        <input
                            type="text"
                            id="producer"
                            v-model="form.producer"
                            name="producer"
                            placeholder="Ex: Interno ou Nome do Produtor"
                            class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                            required
                        />
                    </div>
                </div>

                <div>
                    <label class="text-white"> Serviço </label>
                    <input
                        v-model="form.service"
                        type="text"
                        id="service"
                        name="service"
                        class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                        placeholder="Ex: Dash, Mozart, Checkout, Aplicativo"
                        required
                    />
                </div>

                <div class="mt-3">
                    <label class="text-white"> Texto </label>
                    <textarea
                        v-model="form.text"
                        type="text"
                        id="text"
                        name="text"
                        class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                        placeholder="Ex: Testes em QA"
                        required
                    ></textarea>
                </div>

                <div class="mt-3">
                    <label class="text-white"> Anexos </label>
                    <file-pond
                        name="image_url"
                        ref="pond"
                        class-name="my-pond"
                        label-idle="Arraste ou clique para adicionar arquivos..."
                        allow-multiple="true"
                        accepted-file-types="image/jpeg, image/png"
                        :server="{
                            process: uploadFile,
                        }"
                    />
                </div>
            </div>
            <div class="mt-4 flex justify-center">
                <submit-button :loading="loading" :disabled="loading">
                    Salvar
                </submit-button>
            </div>
        </form>
    </modal>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";

const FilePond = vueFilePond(FilePondPluginImagePreview);

import {
ArchiveBoxIcon,
ArrowLeftIcon,
CheckCircleIcon,
DevicePhoneMobileIcon,
DocumentIcon,
FunnelIcon,
LinkIcon,
PencilIcon,
PlusCircleIcon,
PlusIcon,
PrinterIcon,
StopCircleIcon,
TrashIcon,
VideoCameraIcon,
} from "@heroicons/vue/24/outline";
import { useToast } from "vue-toastification";
import SubmitButton from "../../../components/forms/SubmitButton.vue";
import UsersSelect from "../../../components/forms/UsersSelect.vue";
import VueSelect from "../../../components/forms/VueSelect.vue";
import EmptyState from "../../../components/layouts/EmptyState.vue";
import Filters from "../../../components/layouts/Filters.vue";
import Modal from "../../../components/layouts/Modal.vue";
import TictoLoading from "../../../components/layouts/TictoLoading.vue";
import Manager from "../../../components/manager/Manager.vue";
import StoreModal from "../../../components/manager/modals/StoreModal.vue";

export default {
    components: {
        EmptyState,
        StoreModal,
        Manager,
        VueSelect,
        UsersSelect,
        TictoLoading,
        DevicePhoneMobileIcon,
        CheckCircleIcon,
        VideoCameraIcon,
        PlusCircleIcon,
        PencilIcon,
        FontAwesomeIcon,
        StopCircleIcon,
        TrashIcon,
        Filters,
        Modal,
        SubmitButton,
        ArchiveBoxIcon,
        DocumentIcon,
        FunnelIcon,
        LinkIcon,
        PrinterIcon,
        ArrowLeftIcon,
        PlusIcon,
        FilePond,
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            isDrawerOpen: false,
            loading: false,
            modal: false,
            video: null,
            releaseNew:null,
            release:null,
            modalAnexos: false,
            counter: 0,
            form: {
                id: null,
                title: null,
                producer: null,
                service: null,
                release_note_id: null,
                text: null,
                image_url: [],
            },
            releases: [],
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11,
            },
            filters: {
                text: "",
            },
            next_page_url: false,
        };
    },

    computed: {
        releaseId() {
            return this.$route.params.release_id;
        },
    },

    mounted() {
        this.fetch();
    },

    methods: {
        returnRedirect() {
            this.$router.push({
                name: "release",
            });
        },
        openmodalAnexos(video) {
            this.release = video
            axios
                .get(
                    `/api/releases/${this.$route.params.release_id}/description/${video.id}/images`,
                )
                .then(({ data }) => {
                    this.video = data;
                    this.modalAnexos = true;
                });
        },
        fetch() {
            this.loading = true;
            const params = this.filters;

            const releasePromise = axios
                .get(`/api/releases/${this.$route.params.release_id}`, {
                    params: params,
                })
                .then(({ data }) => {
                    this.releaseNew = data;
                });

            const descriptionsPromise = axios
                .get(
                    `/api/releases/${this.$route.params.release_id}/description`,
                    {
                        params: params,
                    },
                )
                .then(({ data }) => {
                    this.releases = data.data;
                });

            Promise.all([releasePromise, descriptionsPromise])
                .catch((error) => {
                    this.toast.error(
                        error.response?.data?.message ||
                            "Não foi possível carregar os detalhes.",
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        extractValidationMessage(error, fallback) {
            const errors = error.response?.data?.errors;
            if (errors && typeof errors === "object") {
                const first = Object.values(errors)[0];
                if (Array.isArray(first) && first.length) {
                    return first[0];
                }
                if (typeof first === "string") {
                    return first;
                }
            }
            return error.response?.data?.message || fallback;
        },
        openModal(description) {
            this.closeModal();
            if (description) {
                this.form.title = description.title;
                this.form.producer = description.producer;
                this.form.service = description.service;
                this.form.text = description.text;
                this.form.id = description.id;
                this.form.image_url = Array.isArray(description.image_url)
                    ? description.image_url
                    : [];
            } else {
                this.form.id = null;
            }
            this.modal = true;
        },
        closeModal() {
            this.video = [];
            this.form.title = null;
            this.form.producer = null;
            this.form.service = null;
            this.form.text = null;
            this.form.image_url = [];
            this.loading = false;
            this.modal = false;
        },
        destroy(id) {
            this.loading = true;
            axios
                .delete(
                    `/api/releases/${this.$route.params.release_id}/description/${id}`,
                )
                .then(() => {
                    this.toast.success("Descrição deletada com sucesso!");
                    this.closeModal();
                    this.fetch();
                })
                .catch((error) => {
                    this.toast.error(
                        this.extractValidationMessage(
                            error,
                            "Ocorreu um erro, tente novamente!",
                        ),
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        destroyImage(id) {
            this.loading = true;
            axios
                .post(
                    `/api/releases/${this.$route.params.release_id}/description/${this.release.id}/images`,
                    { id: id },
                )
                .then(() => {
                    this.toast.success("Anexo deletado com sucesso!");
                    this.closeModal();
                    this.fetch();
                })
                .catch((error) => {
                    this.toast.error(
                        this.extractValidationMessage(
                            error,
                            "Ocorreu um erro, tente novamente!",
                        ),
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submitForm() {
            this.loading = true;

            this.form.release_note_id = this.$route.params.release_id;

            const isCreating = this.form.id == null;
            const request = isCreating
                ? axios.post(
                      `/api/releases/${this.$route.params.release_id}/description`,
                      this.form,
                  )
                : axios.put(
                      `/api/releases/${this.$route.params.release_id}/description/${this.form.id}`,
                      this.form,
                  );

            const successMessage = isCreating
                ? "Detalhe cadastrado com sucesso!"
                : "Descrição alterada com sucesso!";

            request
                .then(() => {
                    this.toast.success(successMessage);
                    this.closeModal();
                    this.fetch();
                })
                .catch((error) => {
                    this.toast.error(
                        this.extractValidationMessage(
                            error,
                            "Ocorreu um erro, tente novamente!",
                        ),
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // !!! TODO - componentizar o upload de imagem
        async store(file, options = null) {
            const response = await axios.post(
                "/vapor/signed-storage-url",
                {
                    bucket: options.bucket || "",
                    content_type: options.contentType || file.type,
                    expires: options.expires || "",
                    visibility: "public-read",
                    ...options.data,
                },
                {
                    // baseURL: options.baseURL || null,
                    ...options.options,
                },
            );

            if (response.status !== 200 && response.status !== 201) {
                throw new Error("Erro ao fazer upload.");
            }

            let headers = response.data.headers;

            if ("Host" in headers) {
                delete headers.Host;
            }

            if (typeof options.progress === "undefined") {
                options.progress = () => {};
            }

            const cancelToken = options.cancelToken || "";

            await axios.put(response.data.url, file, {
                cancelToken: cancelToken,
                headers: headers,
                withCredentials: false,
                onUploadProgress: (progressEvent) => {
                    options.progress(
                        progressEvent.loaded / progressEvent.total,
                    );
                },
            });

            response.data.extension = file.name.split(".").pop();

            return response.data;
        },
        uploadFile(
            fieldName,
            file,
            metadata,
            load,
            error,
            filePondProgress,
            abort,
        ) {
            this.store(file, {
                progress: async (progress) => {
                    filePondProgress(Math.round(progress * 100));
                },
                abort,
            })
                .then((response) => {
                    load(response);
                    if (!Array.isArray(this.form.image_url)) {
                        this.form.image_url = [];
                    }
                    if (response?.key) {
                        this.form.image_url.push(response.key);
                    }
                })
                .catch(() => {
                    abort();
                    this.form.image_url = [];
                    this.toast.error("Falha ao enviar o arquivo.");
                });
        },
        handleDeleteImage() {
            this.form.image_url = null;
        },
    },
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}
.slide-enter,
.slide-leave-to {
    transform: translateX(-100%);
}
</style>
